import { useNavigate } from "@tanstack/react-router";
import { Button } from "@/components/base/buttons/button";
import { Tooltip, TooltipTrigger } from "@/components/base/tooltip/tooltip";
import { useMerchant } from "@/providers/MerchantProvider";

type ReviewSampleRequestsButtonProps = {
  collaborationId: string;
  sampleRequestedCount: number;
  collaborationType?: "target" | "open";
};

export const ReviewSampleRequestsButton = ({
  collaborationId,
  sampleRequestedCount,
  collaborationType = "target",
}: ReviewSampleRequestsButtonProps) => {
  const merchant = useMerchant();
  const navigate = useNavigate();

  if (sampleRequestedCount === 0) {
    return (
      <Tooltip title="No sample requests to review.">
        <TooltipTrigger>
          <span>
            <Button color="primary" size="sm" isDisabled>
              Sample Requests
            </Button>
          </span>
        </TooltipTrigger>
      </Tooltip>
    );
  }

  const to =
    collaborationType === "open"
      ? "/merchant/$merchantId/collaborations/open/$collaborationId/sample-requests"
      : "/merchant/$merchantId/collaborations/target/$collaborationId/sample-requests";

  return (
    <Button
      color="primary"
      size="sm"
      onClick={() =>
        navigate({
          to,
          params: { merchantId: merchant, collaborationId },
        })
      }
    >
      Sample Requests
    </Button>
  );
};
